import React from "react";
import { graphql } from "react-apollo";
import { flowRight as compose } from "lodash";
import gql from "graphql-tag";
import {connect} from "react-redux";
import Form from "./CartPoliciesForm";
import Loading from "../../components/Loading";
import GraphQLErrors from "../../components/GraphQLErrors";
import {cancelChangeCartPolicies} from "../../actions/AccountApiActions";
import {fromJS, Map} from "immutable";
import {createValidationErrors, createErrors} from "../../lib/ErrorFormatter";

function validateForm(values) {
  let errors = Map();
  // errors = validatePresence(errors, values, "allowedSubscriptions");
  // errors = validatePresence(errors, values, "allowedProductOrders");
  // errors = validatePresence(errors, values, "allowedWaterOrders");
  return errors.toJS();
}

class ChangeCartPoliciesFormContainer extends React.Component {

  constructor(props) {
    super(props);
    this.state = { errors: [] }
  }

  handleSubmit(values) {
    return this.props.changeCartPolicies(values.set("accountId", this.props.accountId).toJS())
      .then((response) => {
        if (response.data.changeCartPolicies.errors.length <= 0) {
          this.props.cancelChangeCartPolicies();
        } else {
          let errors = createValidationErrors(response.data.changeCartPolicies.errors);
          this.setState({errors: errors});
        }
      })
      .catch((err) => {
        this.setState({errors: createErrors(err)});
      });      
  }

  handleCancel() {
    this.props.cancelChangeCartPolicies();
  }

  render() {
    let {data} = this.props;
    if (data.loading) return <Loading />
    if (data.error) return <GraphQLErrors error={data.error} />
    let initialValues = fromJS(data.cart).delete("__typename");
    return (
      <Form
        initialValues={initialValues}
        errors={this.state.errors}
        validate={validateForm}
        onSubmit={this.handleSubmit.bind(this)}
        onCancel={this.handleCancel.bind(this)}
        />
    )
  }

}


const CART_POLICIES = gql`
  query cart($accountId: ID!) {
    cart(accountId: $accountId) {
      subscriptionsPolicy
      productOrdersPolicy
      waterOrdersPolicy
    }
  }
`;

const CHANGE_POLICIES = gql`
  mutation changeCartPolicies($data: CartPoliciesInput!) {
    changeCartPolicies(input: $data) {
      errors { key message }
    }
  }
`;

const withQueries = compose(
  graphql(CART_POLICIES, {
    options: (props) => ({
      fetchPolicy: "network-only",
      variables: {
        accountId: props.accountId
      }
    })
  }),
  graphql(CHANGE_POLICIES, {
    props: ({ mutate }) => ({
      changeCartPolicies: (data) => mutate({
        variables: { data: data }
      })
    })
  })  
);

export default connect(null, {cancelChangeCartPolicies})(withQueries(ChangeCartPoliciesFormContainer));